module.exports = __webpack_public_path__ + "media/assets/images/payments/lightning-fbe58aa0b4a8de13489245b14c89d298.png";